import instance from "../axios";

export const createRefunds = async (data) => {
  const response = await instance.post("refunds/create", data);
  return response.data;
};

export const updateRefunds = async (data) => {
  const response = await instance.post("refunds/update", data);
  return response.data;
};

export const uploadReceipt = async (imageUpload, boothId, date) => {
  var formData = new FormData();
  formData.set("myFile", imageUpload, imageUpload.name);
  formData.append("boothId", boothId);
  formData.append("date", date);
  const response = await instance.post(`refunds/upload-receipt`, formData);
  return response;
};

export const uploadEvidence = async (imageUpload, boothId, date) => {
  var formData = new FormData();
  formData.set("myFile", imageUpload, imageUpload.name);
  formData.append("boothId", boothId);
  formData.append("date", date);
  const response = await instance.post(`refunds/upload-evidence`, formData);
  return response;
};

export const getRefundNoteOptions = async () => {
  const response = await instance.get("refunds/get-refund-note-options");
  return response.data;
};
